import LoadingModal from './LoadingModal';
export default LoadingModal;



// WEBPACK FOOTER //
// ./src/components/Modal/LoadingModal/index.js